module.exports = __webpack_public_path__ + "img/hailan.7f6c8599.png";